/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {
	CSSProperties,
	ReactNode
} from "react";
import {
	TooltipBuilder,
	TooltipDefaultStyle,
	TooltipModule
} from "@intuitionrobotics/thunderstorm/frontend";
import {COLORS} from "@res/colors";

/***********************/
/* App general tooltip */
/***********************/

const tooltipStyle: CSSProperties = {
	backgroundColor: "#fffcf3",
	borderRadius: 11,
	border: `solid 1px ${COLORS.grays_2}`,
	color: COLORS.grays_dark,
	fontSize: 11,
	padding: "2px 7px 1px 9px",
	textAlign: "center",
	zIndex: 3
};

export const showTooltip = (e: React.MouseEvent, content: ReactNode, x: number = e.clientX + 10, y: number = e.clientY + 10, _css?: CSSProperties) => {
	new TooltipBuilder(content, e)
		.setLocation(x, y)
		.setDuration(0)
		// @ts-ignore
		.setStyle({...TooltipDefaultStyle, ...tooltipStyle, ..._css})
		.show();
};

export const showTooltipAtXY = (content: React.ReactNode, x: number, y: number, _css?: CSSProperties, duration?: number) => {
	new TooltipBuilder(content)
		.setLocation(x, y)
		// @ts-ignore
		.setStyle({...TooltipDefaultStyle, ...tooltipStyle, ..._css})
		.setDuration(duration || 0)
		.show();
};

export const hideTooltip = () => TooltipModule.hide();
